import { TripRequestedNotification } from './components/TripRequestedNotification';
import type { NotificationMetaDataCallback } from './types';

export const FacilityTripRequestedRenderer = TripRequestedNotification;

export const getMetaData: NotificationMetaDataCallback = (_notification) => {
  return {
    title: 'Trip Requested (Facility Portal)',
  };
};
